import axios from 'axios';
import { HTTP_CONFIG } from '@/config/config.js'

const API_BASE_URL = HTTP_CONFIG.API_BASE_URL; 

// 创建点位信息
export const createPointMessage = (data) => {
  return axios.post(`${API_BASE_URL}substation/create_point_message/`, data);
};

// 查询点位信息
export const queryPointMessage = (params) => {
  return axios.get(`${API_BASE_URL}substation/query_point_message/`, { params });
};

// 更新点位信息
export const updatePointMessage = (id, data) => {
  return axios.put(`${API_BASE_URL}substation/update_point_message/${id}/`, data);
};

// 删除点位信息
export const deletePointMessage = (id) => {
  return axios.delete(`${API_BASE_URL}substation/delete_point_message/${id}/`);
};

// 获取点位详情
export const getPointMessageDetail = (id) => {
  return axios.get(`${API_BASE_URL}substation/point_message_detail/${id}/`);
};

// 查询违规信息
export const queryViolations = (params) => {
  return axios.get(`${API_BASE_URL}substation/query_violations/`, { params });
};

// 创建违规信息
export const createViolation = (data) => {
  return axios.post(`${API_BASE_URL}substation/create_violation/`, data);
};

// 创建维修信息
export const createMaintenance = (data) => {
  return axios.post(`${API_BASE_URL}substation/create_maintenance/`, data);
};

// 查询维修信息
export const queryMaintenance = (params) => {
  return axios.get(`${API_BASE_URL}substation/query_maintenance/`, { params });
}; 